import { BaseSiteState, BoelsBaseSite } from '@boels/models';
import { createReducer, on } from '@ngrx/store';
import {
  loadBaseSitesSuccess,
  setActiveBaseSite,
} from '../actions/site-context.actions';

export { BaseSiteState };

export const initialState: BaseSiteState = {
  entities: {},
  details: {},
  activeSite: '',
  isocodes: [],
  onlineIsocodes: [],
};

export const reducer = createReducer(
  initialState,
  on(setActiveBaseSite, (state, { payload }) => ({
    ...state,
    details: state.entities[payload] ?? {},
    activeSite: payload,
  })),
  on(loadBaseSitesSuccess, (state, { baseSites, isInSmartEdit }) => {
    baseSites = baseSites.map((site) => {
      site.showOnLanguageSelector = isInSmartEdit ? true : site.online;
      return site;
    });
    const entities = baseSites.reduce(
      (siteEntities: { [uid: string]: BoelsBaseSite }, site: BoelsBaseSite) => {
        return {
          ...siteEntities,
          [site.uid ?? '']: site,
        };
      },
      {
        ...state.entities,
      },
    );

    const details = entities[state.activeSite];

    const isocodes: string[] = isoCodeMapper(baseSites);
    const onlineIsocodes: string[] = isoCodeMapper(
      baseSites.filter((site) => site.showOnLanguageSelector),
    );

    return {
      ...state,
      details,
      entities,
      isocodes,
      onlineIsocodes,
    };
  }),
);

const isoCodeMapper = (baseSites: BoelsBaseSite[]) => {
  const isocodes: string[] = [];
  baseSites.forEach((baseSite: BoelsBaseSite) => {
    baseSite.stores?.forEach((store) => {
      store.languages?.forEach((language) => {
        let isocode = language.isocode ?? '';
        if (isocode === 'en') {
          isocode = isocode + '-' + baseSite.country?.isocode;
        }
        isocode = isocode?.replace('_', '-');
        if (-1 === isocode.indexOf('-')) {
          isocode = isocode + '-' + baseSite.country?.isocode;
        }
        isocode = isocode.toLowerCase();
        if (!isocodes.find((test) => test === isocode)) {
          isocodes.push(isocode);
        }
      });
    });
  });

  return isocodes;
};
